<template>
  <div :class="['time_counter_box flex-row', {ending: isTimerEndingActive}]">
    <base-image :src="timerIcon" />

    <div :class="['time_counter', {ending: isTimerEndingActive}]">
      {{ timerInSeconds |  formatTimerFilter }}
    </div>
  </div>
</template>

<script>
import { formatTime } from '../../../../../helpers/common';
import BaseImage from '../../../../common/image/BaseImage.vue';

export default {
  name: 'AddOnGameTimer',
  components: { BaseImage },
  emits: ['time:expired'],
  props: {
    startImmediate: {
      type: Boolean,
      default: false,
    },
    initialTimerInSeconds: {
      type: Number,
      default: 60,
    },
  },
  filters: {
    formatTimerFilter: value => formatTime(value, '00:00'),
  },
  data () {
    return {
      timerInSeconds: 0,
      timerIntervalId: null,
      timerIntervalDelay: 1000,
      timerEndingLimitStartInSeconds: 10,
    };
  },
  mounted () {
    this.timerInSeconds = this.initialTimerInSeconds;

    if (this.startImmediate) {
      this.$nextTick(() => {
        this.startTimer();
      });
    }
  },
  computed: {
    isTimerEndingActive () {
      return this.timerInSeconds <= this.timerEndingLimitStartInSeconds;
    },
    timerIcon () {
      return this.isTimerEndingActive
        ? '/static/images/clock_red.svg'
        : '/static/images/clock_white.svg';
    },
  },
  methods: {
    stopTimer () {
      if (this.timerIntervalId) {
        clearInterval(this.timerIntervalId);
        this.timerIntervalId = null;
      }
    },
    startTimer (initialTimer) {
      this.timerInSeconds = initialTimer || this.initialTimerInSeconds;

      if (this.timerInSeconds <= 0) { return; }

      this.timerIntervalId = setInterval(() => {
        --this.timerInSeconds;

        if (this.timerInSeconds <= 0) {
          this.stopTimer();

          this.$emit('time:expired');
        }
      }, this.timerIntervalDelay);
    },
  },
  beforeDestroy () {
    this.stopTimer();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOnGame/components/AddOnGameTimer.vue